/* Mobile slider for sections/product-how-it-works.liquid. The track is a
   native scroll-snap row (so swipe works without a library); the arrows just
   scroll it by one column. On desktop the track doesn't overflow, so the
   buttons are hidden by CSS and this is inert. */
function initProductHowItWorksSliders(root) {
  (root || document).querySelectorAll('[data-product-slider]').forEach((slider) => {
    if (slider.dataset.sliderReady) return;
    slider.dataset.sliderReady = 'true';

    const track = slider.querySelector('[data-product-slider-track]');
    const prev = slider.querySelector('[data-product-slider-prev]');
    const next = slider.querySelector('[data-product-slider-next]');
    if (!track || !prev || !next) return;

    const step = () => {
      const first = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return first ? first.getBoundingClientRect().width + gap : track.clientWidth;
    };

    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  });
}

initProductHowItWorksSliders(document);
document.addEventListener('shopify:section:load', (event) => initProductHowItWorksSliders(event.target));
